export default {
  pages: {
    registrationComplete: {
      header: 'Rahmat kattakon! Tez orada bizning mutaxassislarimiz siz bilan aloqaga chiqishadi',
      pleaseWait: 'Iltimos, bizning mutaxassislarimiz siz bilan aloqaga chiqishini kuting!',
      ok: 'Tushunarli',
    },
  },
};
